//@ts-check
class CSliderGallery extends HTMLElement {
  constructor() {
    super()
    /** @type {HTMLElement|null} */
    this.sliderInside = this.querySelector('[data-slider-inside') || null
    this.bullets = [...this.querySelectorAll('[data-slider-bullet')]
  }

  connectedCallback() {
    // Observer les éléments aux extrémités du slider
    this.setupObservers()
    // Ajouter les event listeners sur les bullets
    this.setupBulletListeners()
  }

  disconnectedCallback() {
    // Déconnecter les observers
    this.intersectionObserver?.disconnect()
    this.resizeObserver?.disconnect()
  }

  setupObservers() {
    if (!this.sliderInside) return
    const slides = [...this.sliderInside.querySelectorAll('[data-slide]')]
    if (slides.length === 0) return

    const firstSlide = slides[0]
    const lastSlide = slides[slides.length - 1]

    // IntersectionObserver pour détecter les éléments visibles
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === firstSlide) {
            this.isAtStart = entry.isIntersecting
          }

          if (entry.target === lastSlide) {
            this.isAtEnd = entry.isIntersecting
          }

          // Mettre à jour le bullet actif quand un slide devient visible
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            const slideIndex = slides.indexOf(entry.target)

            this.updateActiveBullet(slideIndex)
          }
        })
      },
      {
        root: this,
        threshold: [0.5, 0.95], // Détecter à 50% et 95% de visibilité
      }
    )

    // Observer tous les slides pour détecter celui qui est visible
    slides.forEach((slide) => {
      this.intersectionObserver?.observe(slide)
    })

    // ResizeObserver pour réagir aux changements de taille
    this.resizeObserver = new ResizeObserver(() => {})

    this.resizeObserver.observe(this)
  }

  /**
   * Met à jour le bullet actif en fonction de l'index du slide
   * @param {number} index - Index du slide actif
   */
  updateActiveBullet(index) {
    this.bullets.forEach((bullet, i) => {
      if (i === index) {
        bullet.classList.add('is-active')
      } else {
        bullet.classList.remove('is-active')
      }
    })
  }

  /**
   * Configure les event listeners pour les bullets
   */
  setupBulletListeners() {
    if (!this.sliderInside) return
    const slides = [...this.sliderInside.querySelectorAll('[data-slide]')]

    this.bullets.forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        const targetSlide = slides[index]
        if (targetSlide) {
          // Scroll vers le slide correspondant
          targetSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          })
        }
      })
    })
  }
}
if (!customElements.get('c-slider-gallery')) {
  customElements.define('c-slider-gallery', CSliderGallery)
}
